<app-add-new-location-step-one-dialog [callbackFunction]="openAddLocationDataDialog"
    [toast]="toast"></app-add-new-location-step-one-dialog>
<app-add-new-location-dialog [reloadLocationsCallbackFunction]="loadLocationsCallback" [toast]="toast"
    [deleteCallbackFunction]="deleteCallbackFunction"></app-add-new-location-dialog>
<app-delete-location-dialog [reloadLocationsCallbackFunction]="loadLocationsCallback"></app-delete-location-dialog>
<app-confirm-locations-dialog [inactiveLocations]="inactiveLocations"
    [reloadLocationsCallbackFunction]="loadLocationsCallback"></app-confirm-locations-dialog>

<app-toast></app-toast>

<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.locations' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'shared.overview' | transloco }}" [isActive]="true"
                    link="/locations/overview"></app-tab-button>
            </div>

            <!-- Locations -->
            <div class="mt-4 h-auto w-full max-w-ultrawide rounded-[20px] border-[1px] border-border flex flex-col p-5">
                <div class="flex justify-between items-center">
                    <h2 class="text-2xl font-bold">{{ 'shared.pages.locations' | transloco }}</h2>
                    <div class="w-[200px] h-[45px]">
                        <app-custom-button buttonText="{{ 'locations.add_locations' | transloco }}"
                            (buttonClick)="openNewLocationUploadDialog()" leadingIcon="assets/icons/add.svg"
                            backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                            hoverBackgroundColor="hover:bg-primary-1200"></app-custom-button>
                    </div>
                </div>
                <div class="h-full mt-5">
                    <app-location-info *ngIf="!locationsLoaded"></app-location-info>
                    <p class="text-black" *ngIf="locations.length === 0 && locationsLoaded">{{
                        'locations.no_added_locations' | transloco }}</p>
                    <ng-container *ngFor="let location of locations; let i = index">
                        <app-location-info [displayNumber]="(i+1)" [location]="location" *ngIf="locationsLoaded"
                            [editLocationCallbackFunction]="editLocation"
                            [locationConsumption]="locationDataMap[location.id] || null"
                            [locationElectricityData]="locationElectricityDataMap[location.id] || null"
                            [locationGasData]="locationGasDataMap[location.id] || null"></app-location-info>
                    </ng-container>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>